import { useEffect } from 'react'
import StepsIndicator from '../../components/LibertyLakeV2/StepsIndicator/StepsIndicator'
import Footer from '../../components/LibertyLakeV2/Footer/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../redux'
import Step1 from '../../components/LibertyLakeV2/Steps/Step1/Step1'
import Step2 from '../../components/LibertyLakeV2/Steps/Step2/Step2'
import Step3 from '../../components/LibertyLakeV2/Steps/Step3/Step3'
import axios, { AxiosResponse } from 'axios'
import Step4 from '../../components/LibertyLakeV2/Steps/Step4/Step4'
import appSlice from '../../redux/slice/app.slice'
import logo from '../../assets/icons/libertyLakeLogo.png'
import { config } from '../../config'
import libertyLakeSlice from '../../redux/slice/libertyLake.slice'
import { LibertyLakeConfigResponse } from '../../types/libertyLakeV2'

export const LibertyLakeV2 = () => {
  const dispatch: AppDispatch = useDispatch()
  const { step } = useSelector((state: RootState) => state.libertyLake)
  const { isLoading } = useSelector((state: RootState) => state.app)

  const renderRespectiveStep = () => {
    if (step === 1) {
      return <Step1 />
    } else if (step === 2) {
      return <Step2 />
    } else if (step === 3) {
      return <Step3 />
    } else if (step === 4) {
      return <Step4 />
    } else {
      return null
    }
  }

  const fetchAdminConfiguration = async () => {
    dispatch(appSlice.actions.setLoading(true))
    try {
      const response: AxiosResponse<LibertyLakeConfigResponse> = await axios({
        url: config.libertyLakeAdminPanelSpreadsheetUrl,
        method: 'GET',
        params: {
          apiKey: config.libertyLakeApiKey
        }
      })

      if (
        response.data?.message === 'Incorrect api key' ||
        (response.status !== 200 &&
          response.statusText !== 'OK' &&
          !response?.data?.success)
      ) {
        console.error('Error getting rows from GoogleSheet', response.data)
        throw new Error(
          `Error getting rows from GoogleSheet: ${response?.data?.message as string}`
        )
      }
      dispatch(libertyLakeSlice.actions.setConfig(response.data?.data))
      dispatch(appSlice.actions.setLoading(false))
      return response.data?.data
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  useEffect(() => {
    fetchAdminConfiguration()
  }, [])

  return <>
    <div className={'libertyLake'}>
      <div className="contentArea">
        <div className="title">
          <img src={logo} className='logo' />
          Liberty Lake Pricing Calculator
        </div>
        <StepsIndicator />
        <div className='stepsContainer'>
          {renderRespectiveStep()}
        </div>
        <Footer />
      </div>
      {isLoading && <div className='loadingPanel'>
        <div className="lds-ripple"><div></div><div></div></div>
      </div>}
    </div>
  </>
}
